import ProductService from '@/api/services/ProductService';
import { rest } from '@/api/axios';

export const namespaced = true;

export const state = {
  groups: [],
  style: {},
  loading: false,
  loadingPetPhoto: false,
};

export const mutations = {
  SET_GROUPS(state, groups) {
    state.groups = groups;
  },
  SET_STYLE(state, style) {
    state.style = style;
  },
  LOADING(state, loading) {
    state.loading = loading;
  },
  LOADING_AVATAR(state, loading) {
    state.loadingPetPhoto = loading;
  },
  ADD_LOADING_AVATAR(state, { image }) {
    state.style.petPhotos?.push(image);
  },
  REMOVE_LOADING_AVATAR(state) {
    state.style.petPhotos = state.style.petPhotos?.filter(function (image) {
      return image.id !== 'temp';
    });
  },
  ADD_AVATAR_TO_PET(state, { image }) {
    const newImage = { original: image.image, id: image.id, loading: false };
    state.style.petPhotos?.push(newImage);
  },
};

export const actions = {
  fetchGroups({ commit, dispatch }, { cityId }) {
    commit('LOADING', true);
    return new Promise((resolve, reject) =>
      ProductService.getGroupsWithStyles(cityId, 'WALLET_CARD')
        .then((response) => {
          commit('SET_GROUPS', response);
          commit('LOADING', false);
          resolve(response);
        })
        .catch((error) => {
          commit('SET_GROUPS', []);
          commit('LOADING', false);
          error.location = 'fetchGroups';
          dispatch(
            'notification/notifyFailure',
            { message: 'There was an error loading our pawesome products.', options: { dismissSecs: 15 } },
            { root: true }
          );
          reject(error);
        })
    );
  },
  removeGroup({ commit }) {
    commit('SET_GROUP', []);
  },
  fetchWalletCardCustomization({ commit, dispatch }, { petId, productStyleId }) {
    return new Promise((resolve, reject) =>
      ProductService.getWalletCardCustomization({ petId, productStyleId })
        .then((response) => {
          commit('SET_STYLE', response);
          resolve(response);
        })
        .catch((error) => {
          commit('SET_STYLE', {});
          error.location = 'fetchWalletCardStyle';
          dispatch(
            'notification/notifyFailure',
            { message: "There was an error loading 'Wallet Card product.'", options: { dismissSecs: 15 } },
            { root: true }
          );
          reject(error);
        })
    );
  },
  setStyle({ commit }, style) {
    if (!style) return;
    commit('SET_STYLE', style);
  },
  setStyleById({ commit, state }, { styleId }) {
    if (!styleId || !state.groups) return;
    let style;
    state.groups?.find((group) => {
      style = group.productStyles?.find((style) => {
        return style.id === styleId;
      });
    });
    commit('SET_STYLE', style);
  },
  removeStyle({ commit }) {
    commit('SET_STYLE', {});
  },
  async uploadPetPhoto({ commit }, { pet, image }) {
    const formData = new FormData();
    formData.append('file', image);

    commit('ADD_LOADING_AVATAR', { image: { id: 'temp', loading: true } });
    commit('LOADING_AVATAR', true);
    return new Promise((resolve, reject) => {
      rest
        .post(`api/pet-profile-image?pet=${pet}`, formData)
        .then((response) => {
          if (response.status == 201 || response.status == 'Created') {
            commit('REMOVE_LOADING_AVATAR', true);
            commit('LOADING_AVATAR', false);
            commit('ADD_AVATAR_TO_PET', { image: response.data });
            resolve(response);
          }
        })
        .catch((error) => {
          error.location = 'uploadPetPhoto';
          const message = "There was an error uploading your pet's photo.";
          reject(message);
        })
        .finally(() => {
          commit('REMOVE_LOADING_AVATAR', true);
          commit('LOADING_AVATAR', false);
        });
    });
  },
};

export const getters = {};
